import { render } from "./NewUserRegistered.vue?vue&type=template&id=a395657e"
import script from "./NewUserRegistered.vue?vue&type=script&lang=js"
export * from "./NewUserRegistered.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__